export default __webpack_public_path__ + "static/media/bh.720f4f9d.svg";